import { ClassValue } from "clsx";

import { cn } from "@/lib/utils";

export function truncatedTextClassName(className?: ClassValue): string {
  return cn("truncate font-medium", className);
}
